// extracted by css-extract-rspack-plugin
export default {"content":"content-l7i4rz","label":"label-ERjBlI","sourceKey":"sourceKey-TsFLvr"};